import { TopicType } from 'app/copied/constants/common';

import { type FAQItem, FAQTypeValue, type SuggestedEntry } from '../copied/models/ChatModules';
import makeApi from './api';

export function getImageItem(result: SuggestedEntry) {
  return result.render_json?.find((item: FAQItem) => item?.reg_id?._type_val === FAQTypeValue.Image);
}

export function getVideoItem(result: SuggestedEntry) {
  return result.render_json?.find((item: FAQItem) => item?.reg_id?._type_val === FAQTypeValue.Video);
}

export function checkIsExternalLinkWithImage(result: SuggestedEntry) {
  return !!(result.external_link && getImageItem(result));
}

export function getTopicType(result: SuggestedEntry) {
  if (checkIsExternalLinkWithImage(result)) {
    return TopicType.ExternalThumbnailLink;
  }
  return result.external_link ? TopicType.ExternalLink : TopicType.Downloadable;
}

export default async function fetchSearchResults({
  uuid,
  search,
  suggested,
  category,
  traceId,
}: {
  uuid?: string;
  search?: string;
  suggested?: boolean;
  category?: string;
  traceId?: string;
}) {
  const params: {
    search_text?: string;
    suggested?: boolean;
    category?: string;
    trace_id?: string;
  } = {};

  if (search) {
    params.search_text = search;
  } else {
    params.suggested = suggested ?? true;
  }

  if (category) {
    params.category = category;
  }

  let config = {};
  if (traceId) {
    config = { params, headers: { 'X-Request-Id': traceId } };
  } else {
    config = { params };
  }

  const api = makeApi();
  const response = await api.get(`/api/v1/web_chat/v3.0/help-center/${uuid}/knowledgebase/`, config);

  return response.data;
}
